import { Component, inject } from '@angular/core';
import { SapMaterialService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapMaterialCreateDto,
  SapMaterialDto,
  SapMaterialExcelDownloadDto,
  SapMaterialUpdateDto,
} from '../proxy/controlling/dtos/sap-material';
import { SAPMATERIAL_CONFIG, SAPMATERIAL_FIELDS } from './sap-material.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-material',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapMaterialService, ConfirmationService],
  templateUrl: './sap-material.html',
  styleUrl: './sap-material.scss',
})
export class SapMaterial extends BaseCrudComponent<
  SapMaterialDto,
  SapMaterialCreateDto,
  SapMaterialUpdateDto,
  SapMaterialExcelDownloadDto
> {
  service = inject(SapMaterialService);
  config = SAPMATERIAL_CONFIG;
  fields = SAPMATERIAL_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapMaterialDto): SapMaterialUpdateDto {
    return {
      sapCode: data.sapCode,
      description: data.description,
      sapMaterialGroupId: data.sapMaterialGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapMaterial';
  }
}
